import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-unsafe-argument -- disable */
/* eslint-disable @typescript-eslint/no-explicit-any -- disable */
import * as React from "react";
export const EditorContext = React.createContext(null);
export const EditorContextProvider = ({ children, }) => {
    const [editor, setEditor] = React.useState(null);
    return (_jsx(EditorContext.Provider, { value: { editor, setEditor }, children: children }));
};
